import { SearchDocumentItem } from '../advanced-search/types';

export const testIsAnyDocumentNotMovable = (
  documents: SearchDocumentItem[] = [],
) => {
  return documents.some((doc) => !doc.permissions.move);
};
